import React from 'react';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

type BadgeType = 'soon' | 'beta' | 'premium';

interface BadgeProps {
    type: BadgeType;
    label?: string;
}

const badgeColors: Record<BadgeType, string> = {
    soon: '#7f8c8d',    // Grau
    beta: '#3498db',    // Blau
    premium: '#8e44ad', // Violett
};

const Badge: React.FC<BadgeProps> = ({ type, label }) => {
    const badgeStyle: React.CSSProperties = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 8px',
        marginLeft: '10px',
        fontSize: '11px',
        lineHeight: '1',
        color: 'white',
        backgroundColor: badgeColors[type],
        borderRadius: '4px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    };

    const iconStyle: React.CSSProperties = {
        fontSize: '12px',
        marginBottom: '1px',
    };

    return (
        <span style={badgeStyle}>
      {type === 'premium' && (
          <MonetizationOnIcon style={iconStyle} />
      )}
            {label ?? type}
    </span>
    );
};

export default Badge;
